angular.module('aprima-facility-api', [
    'restangular',
    'angularLocalStorage',
    'lodash',

    //aprima
    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common'
]);